// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"338a91ed","150":"aecc2875","213":"4e8b5efe","287":"7daa8e68","496":"38a523ed","525":"349e213c","580":"739e3c27","998":"570264db"}[chunkId] + ".chunk.js";
};